import { render, staticRenderFns } from "./verbaleDismissioneSPSC.vue?vue&type=template&id=e4269538"
import script from "./verbaleDismissioneSPSC.vue?vue&type=script&lang=js"
export * from "./verbaleDismissioneSPSC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports